'use client'

import { ImageHelper } from '@/lib/helpers/image.helper'
import { useTranslations } from 'next-intl'
import Image from 'next/image'

export const CareShareFundInfo = () => {
  const t = useTranslations()

  return (
    <div className='relative overflow-hidden rounded-3xl bg-primary px-5 py-8 text-white md:px-16 md:py-12'>
      <div className='grid grid-cols-1 items-center gap-8 md:grid-cols-2'>
        <div className='space-y-4'>
          <p className='font-semibold uppercase'>
            {t('care_and_share_hardcode.fund_info.title')}
          </p>
          <Image
            src={ImageHelper.getImageUrl('/image/August2025/mceclip3_68.png')}
            alt='Care & Share Logo'
            width={140}
            height={50}
            className='h-auto w-36'
          />
          <div className='space-y-2 text-sm md:text-base'>
            <p>{t('care_and_share_hardcode.fund_info.description_1')}</p>
            <p>{t('care_and_share_hardcode.fund_info.description_2')}</p>
            <p>{t('care_and_share_hardcode.fund_info.description_3')}</p>
          </div>
        </div>

        <div className='rounded-2xl bg-white p-6 text-neutral-900'>
          <div className='grid grid-cols-2 gap-4'>
            <div className='col-span-1'>
              <Image
                src={ImageHelper.getImageUrl(
                  '/image/August2025/mceclip2_18.png'
                )}
                alt='QR Code'
                width={200}
                height={200}
                className='h-auto w-full'
              />
            </div>
            <div className='col-span-1 flex flex-col justify-center space-y-2'>
              <Image
                src={ImageHelper.getImageUrl(
                  '/image/August2025/mceclip4_41.png'
                )}
                alt='MB Bank Logo'
                width={100}
                height={30}
                className='h-auto w-24'
              />
              <p className='text-sm md:text-lg'>
                {t('care_and_share_hardcode.fund_info.company_name')}
              </p>
              <p className='text-sm md:text-lg'>
                {t('care_and_share_hardcode.fund_info.stk_label')}
                <strong>
                  {' '}
                  {t('care_and_share_hardcode.fund_info.stk_number')}
                </strong>
              </p>

              <p className='mt-5 text-sm font-semibold md:text-lg'>
                {t('care_and_share_hardcode.fund_info.bank_name')}
              </p>
              <p className='text-xs text-neutral-500'>
                {t('care_and_share_hardcode.fund_info.account_type')}
              </p>
            </div>
          </div>
        </div>
      </div>
      <Image
        src={ImageHelper.getImageUrl('/image/August2025/mceclip5_71.png')}
        alt='Decoration'
        width={100}
        height={100}
        className='absolute right-0 top-0 h-auto w-24'
      />
    </div>
  )
}
